import {UserOPEEnum} from "../UserOPEEnum";
import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {ShareValidationTargetDTO} from "../../dashboard/ValidateShareDraftCB";

class O {
  // Destinatari che non riceverebbero nulla
  invalidTargets!: ShareValidationTargetDTO[];
  // Destinatari che riceverebbero la copia, ma con solo alcune misure: insieme disgiunto dal
  // precedente, e da confermare a parte perché la copia viene comunque creata
  partialTargets!: ShareValidationTargetDTO[];
  warningMessage?: string;
}

/**
 * I Inner Class
 */
class I {
  userMetricGroupId!: number;
  targetUserIds!: number[];
}

/**
 * ValidateShareUserMetricGroupDraftCB class
 */
export class ValidateShareUserMetricGroupDraftCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(UserOPEEnum.ValidateShareUserMetricGroupDraft);
    this.i = new I();
    this.o = new O();
  }

}
